import BaseRepository from '@/api/repositories/BaseRepository';

export default class DamageCaseRepository extends BaseRepository {
	get endpoint() {
		return 'api/damagecases';
	}

	unblockWorkingImagesInCustomerApp(damageCaseId, images) {
		return this.post(
			`${damageCaseId}/workingimages/unblock`,
			{},
			{
				images: images,
			},
		);
	}

	downloadWorkingImages(damageCaseId, data) {
		return this.post(`${damageCaseId}/workingimages/download`, {}, data, { responseType: 'arraybuffer' });
	}

	setEndMandateEarly(damageCaseId, data) {
		return this.put(`${damageCaseId}/updateMandateStatus`, {}, data);
	}

	toggleClose(damageCaseId) {
		return this.post(`${damageCaseId}/toggle-close`, {}, {});
	}
}
